export type FieldConfigurationType = 'date' | 'text';
export type FieldConfigurationGroup = 'professional' | 'ceu' | 'other';
export type FieldConfigurationSource = 'native' | 'custom';

export interface FieldConfigurationSettings {
  is_active: boolean;
  visible_in_form: boolean;
  include_in_reports: boolean;
  notify_on_expiration: boolean;
  include_in_dashboard: boolean;
  order: number;
}

export interface FieldConfiguration {
  field_definition_id: number;
  key: string;
  label: string;
  type: FieldConfigurationType;
  group: FieldConfigurationGroup;
  source: FieldConfigurationSource;
  is_system: boolean;
  has_expiration: boolean;
  settings: FieldConfigurationSettings;
}

export interface FieldConfigurationUpdateRow {
  field_definition_id: number;
  order: number;
  is_active: boolean;
  notify_on_expiration: boolean;
}

export interface CreateFieldDefinitionPayload {
  label: string;
  type: FieldConfigurationType;
  group: FieldConfigurationGroup;
}
